import {navigateTo} from '@typed-router';
import {storeToRefs} from 'pinia';
import {defineNuxtRouteMiddleware, useAsyncData} from '#app';
import {useLazyFeatureFlag} from '@malt/feature-flags';
import {useAdvancedSearchStore} from '~/features/advanced-search/stores/advancedSearch.store';
import {resumableStepName} from '../utils/resolveAllowedStep';
import {ADVANCED_SEARCH_CALIBRATION_PAGE_FLAG, getAdvancedSearchWorkflowSteps} from '../workflow';

export default defineNuxtRouteMiddleware(async (to) => {
    const advancedSearchStore = useAdvancedSearchStore();
    const {advancedSearch} = storeToRefs(advancedSearchStore);

    if (!advancedSearch.value) {
        return;
    }

    if (to.name === 's-advanced-briefId') {
        const briefId = to.params.briefId as string;

        const {data: advancedSearchCalibrationPage} = await useAsyncData(ADVANCED_SEARCH_CALIBRATION_PAGE_FLAG, () =>
            useLazyFeatureFlag(ADVANCED_SEARCH_CALIBRATION_PAGE_FLAG),
        );
        const steps = getAdvancedSearchWorkflowSteps('unified', advancedSearchCalibrationPage.value ?? false);
        const allowedStep = resumableStepName(steps, advancedSearch.value, 'unified');

        return navigateTo(
            {
                name: 's-advanced-briefId-step',
                params: {briefId, step: allowedStep},
                query: {resumeDraft: 'true'},
            },
            {replace: true},
        );
    }
});
